import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import {
  ZOHO_SALESIQ_WIDGET_CODE,
  ZOHO_SALESIQ_WIDGET_URL,
} from "../../constants";

const SCRIPT_ID = "zsiqscript";
const DEFAULT_WIDGET_URL = "https://salesiq.zohopublic.com/widget";

const cleanEnv = (value) =>
  String(value || "")
    .trim()
    .replace(/^['"]|['"]$/g, "");

const identifyStudent = (userData) => {
  const visitor = window.$zoho?.salesiq?.visitor;
  if (!visitor || !userData?.id) return;

  try {
    visitor.id(String(userData.id));

    if (userData.name) {
      const parts = String(userData.name).trim().split(/\s+/);
      visitor.name({
        firstname: parts[0],
        lastname: parts.slice(1).join(" ") || parts[0],
      });
    }

    if (userData.email) {
      visitor.email(userData.email);
    }

    if (userData.phone && visitor.contactnumber) {
      visitor.contactnumber(String(userData.phone));
    }

    if (visitor.info) {
      visitor.info({
        StudentId: String(userData.id),
        Grade: userData.grade?.name || "",
        Group: userData.group?.name || "",
        Subject: userData.subject?.name || "",
      });
    }
  } catch (error) {
    // Widget APIs can differ slightly by SalesIQ region/version.
  }
};

const buildScriptSrc = (widgetUrl, widgetCode) => {
  if (widgetUrl.includes("wc=")) return widgetUrl;
  const separator = widgetUrl.includes("?") ? "&" : "?";
  return `${widgetUrl}${separator}wc=${widgetCode}`;
};

const ZohoSalesIQ = () => {
  const userData = useSelector((state) => state.user.userData);
  const userDataRef = useRef(userData);
  const widgetCode = cleanEnv(ZOHO_SALESIQ_WIDGET_CODE);
  const widgetUrl = cleanEnv(ZOHO_SALESIQ_WIDGET_URL) || DEFAULT_WIDGET_URL;

  userDataRef.current = userData;

  useEffect(() => {
    if (!widgetCode) return undefined;

    window.$zoho = window.$zoho || {};
    window.$zoho.salesiq = window.$zoho.salesiq || {
      ready: function () {},
    };
    window.$zoho.salesiq.ready = function () {
      identifyStudent(userDataRef.current);
    };

    if (!document.getElementById(SCRIPT_ID)) {
      const script = document.createElement("script");
      script.id = SCRIPT_ID;
      script.defer = true;
      script.src = buildScriptSrc(widgetUrl, widgetCode);
      document.body.appendChild(script);
    } else {
      identifyStudent(userDataRef.current);
    }

    return undefined;
  }, [widgetCode, widgetUrl]);

  useEffect(() => {
    if (!widgetCode || !userData?.id) return;
    identifyStudent(userData);
  }, [widgetCode, userData]);

  return null;
};

export default ZohoSalesIQ;
